import type {UserVO} from '@Utils/user.util';
import type {Type} from '@Components/button';

export interface NotificationsPanelProps {
  isMobile: boolean;
  className?: string;
  onClosePanel?: VoidFunction;
}

export enum NotificationsPanelDisplayType {
  LOADING = 1,
  EMPTY = 2,
  LOADED = 3,
  SETTINGS = 4,
  TURN_ON_NOTIFICATIONS = 5,
}

export enum NotificationIconType {
  SUCCESS = 1,
  DANGER = 2,
  AI = 3,
  PRIMARY = 4,
  SECONDARY = 5,
  NEUTRAL = 6,
}

export enum NotificationCategory {
  EVENTS = 1,
  FOLDER = 2,
  BUSINESSPROFILE = 3,
  MAILING_LIST = 4,
  SM_PUBLISHING = 5,
  DESIGNERS = 6,
  POSTER = 7,
  BRANDS = 8,
  COLLABORATION = 9,
}

export enum NotificationStatus {
  READ = 1,
  SEEN = 2,
  NEW = 3,
}

export interface NotificationAJAXResponse {
  new: Notification[];
  today: Notification[];
  yesterday: Notification[];
  others: Notification[];
  notificationSettings: NotificationSettingsPanelData;
}

export interface NotificationUpdateDispatchType {
  today: Notification[];
  yesterday: Notification[];
  others: Notification[];
}

export interface Notification {
  idnotification: number;
  iduser: number;
  hashedId: string;
  status: NotificationStatus;
  notificationCategory: NotificationCategory;
  notificationAction: NotificationAction;
  createdOn: number;
  readOn: string | null;
  itemId: string;
  itemData: string;
}
export enum NotificationApprovalStatus {
  APPROVED = 1,
  DECLINED = 2,
  PENDING = 3,
  NOT_REQUIRED = 4,
}
export interface NotificationsItemData {
  sharedBy: UserVO[];
  redirectionLink: string;
  imageUrl?: string;
  comment?: string;
  message?: string;
  approvalStatus?: NotificationApprovalStatus;
  totalUsers?: number;

  notificationMiniIcon?: string;
  notificationMiniIconType?: NotificationIconType;
  notificationIcon?: string;
  notificationTitle?: string;
  allowAggregation?: boolean;
  aggregationText?: string;
  aggregationRedirectionLink?: string | null;
  buttons?: NotificationsCTA[];
}

export interface NotificationsCTA {
  text: string;
  icon?: string | null;
  type?: Type | null;
  link?: string | null;
  ajaxUri?: string | null;
  textAfterSuccess?: string | null;
  approvalValue?: NotificationApprovalStatus | null;
  iconForTextAfterSuccess?: string | null;
}

export interface NotificationsPanelReduxState {
  newNotifications: Notification[];
  todaysNotifications: Notification[];
  yesterdaysNotifications: Notification[];
  otherNotifications: Notification[];
  panelDisplayType: NotificationsPanelDisplayType;
  notificationSettings: NotificationSettingsPanelData;
  allNotifications: Notification[];
  previousNotificationSettings: NotificationSettingsPanelData;
}

export interface NotificationSettingsPanelData {
  designUpdates: boolean;
  teamUpdates: boolean;
  emailCampaigns: boolean;
  socialMediaPosts: boolean;
  eventsUpdates: boolean;
}

export interface MiniIconStyles {
  className: string;
  hoverClassName: string;
}

export enum NotificationAction {
  COLLABORATOR = 'COLLABORATOR',
  COMMENT = 'COMMENT',
  TEAM_SHARE = 'TEAM_SHARE',
  REQUEST_EDIT_ACCESS = 'REQUEST_EDIT_ACCESS',
  ACCEPT_EDIT_ACCESS = 'ACCEPT_EDIT_ACCESS',
  STATISTICS = 'STATISTICS',
  REGISTRATION = 'REGISTRATION',
  LOW_REPUTATION = 'LOW_REPUTATION',
  PUBLISHED = 'PUBLISHED',
  ERROR_PUBLISHING = 'ERROR_PUBLISHING',
  SCHEDULED = 'SCHEDULED',
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  LIMIT_HIT = 'LIMIT_HIT',
  TEAM_INVITE = 'TEAM_INVITE',
  REJECTION = 'REJECTION',

  COLLABORATOR_ADDED = 'COLLABORATOR_ADDED',
  RESEND_INVITE = 'RESEND_INVITE',

  REMINDERS = 'REMINDERS',
}
